import axiosClient from './axiosClient';

export const getBorrowerTransactions = (params = {}) =>
	axiosClient.get('/api/borrower-transactions', { params });

export const getBorrowerTransactionSummary = () =>
	axiosClient.get('/api/borrower-transactions/summary');

export const createBorrowerTransaction = (payload) =>
	axiosClient.post('/api/borrower-transactions', payload);

export const updateBorrowerTransaction = (id, payload) =>
	axiosClient.put(`/api/borrower-transactions/${id}`, payload);

export const deleteBorrowerTransaction = (id) =>
	axiosClient.delete(`/api/borrower-transactions/${id}`);
